import React, { useContext, useEffect, useRef, useState } from 'react';
import { Body, Footer, Header, Main, closeAnimation } from '../../NecttosComp/Layout/Layout';
import Button from '../../NecttosComp/Button/Button';
import Input from '../../NecttosComp/Input/Input';
import { getAxiosTokenInstance } from '../../utils/axiosInstance';
import { useQuery } from 'react-query';
import { FirebaseContext } from '../../context/FirebaseContext';
import { Table, Tbody, Td, Th, Thead, Tr } from '../../NecttosComp/Table/Table';
import { getAllAccademics } from '../../NecttosComp/APICaller/ApiServices';
import moment from 'moment';
import Input2 from '../../NecttosComp/Input/Input2';
import toast, { Toaster } from 'react-hot-toast';
import Instruction from '../../Documentation/Instruction';


const getFieldDropDowns = (collegeId: any) => async () => {
	const instance = await getAxiosTokenInstance();
	try {
		const resp = await instance.get('/college/action/getAllHierarchy', {
			params: { collegeId },
		});
		if (resp.data.statusCode === 400) {
			throw new Error(resp.data.message || 'API Error');
		} else {
			return resp?.data?.list;
		}
	} catch (error) {
		throw new Error('API Error');
	}
};
const getCollegeUsers = (collegeId: any) => async () => {
	const instance = await getAxiosTokenInstance();
	try {
		const resp = await instance.get('/college/action/getUsers', {
			params: { collegeId },
		});
		if (resp.data.statusCode === 400) {
			throw new Error(resp.data.message || 'API Error');
		} else {
			return resp?.data?.list;
		}
	} catch (error) {
		throw new Error('API Error');
	}
};

interface invoiceManagementProps {
	onClose: () => void;
}

function HierarchyManagemant({ onClose }: invoiceManagementProps) {
	const [values, setValues] = useState<any>({});
	const [showForm, setShowForm] = useState(false);
	const { collegeId } = useContext(FirebaseContext);
	const ref = useRef<any>(null);

	const userskey = ['effectFrom', 'effectTo', 'userIds', 'type'];

	const { data: tableData = [], refetch } = useQuery('getAllAccadamicHolidays', getFieldDropDowns(collegeId));
	const { data: collegeUsers = [] } = useQuery('getUsers', getCollegeUsers(collegeId));

	const editvalues = async (_id: string) => {
		try {
			const instance = await getAxiosTokenInstance();
			instance
				.get('/college/action/getHierarchy/' + _id, { params: { collegeId } })
				.then((resp) => {
					setValues(resp.data.list);
				})
				.catch((err: any) => {
					console.error(err);
				});
		} catch (err) {
			console.log(err);
		}
	}



	const handleDelete = async (_id: string) => {
		try {
			const instance = await getAxiosTokenInstance();
			instance
				.delete('/college/action/deleteHierarchy/' + _id, { params: { collegeId } })
				.then(() => {
					refetch();
				})
				.catch((err: any) => {
					console.error(err);
				});
		} catch (err) {
			console.log(err);
		}
	};

	const valuesForm = async () => {
		try {
			const instance = await getAxiosTokenInstance();

			if (!values?.role || values?.users?.length === 0) {
				toast.error('Feilds are Empty')
				return
			}
			instance
				.post('/college/action/postHierarchy', { ...values, collegeId })
				.then(() => {
					setValues({});
					refetch();
				})
				.catch((err: any) => {
					console.error(err);
				});
			closeAnimation();
			setTimeout(() => setShowForm(false), 500);
		} catch (err) {
			throw new Error('API Error');
		}
	};
	const onAddClick = (type: string) => {
		const currentData = Array.isArray(values?.[type]) ? values[type] : [];
		if (type === 'users') {
			const newData = [...currentData, {}];
			setValues({ ...values, [type]: newData });
		}
	};

	const onDelete = (index: any, arrayName: any) => {
		setValues((prevValues: any) => {
			const updatedArray = [...prevValues[arrayName]];
			updatedArray.splice(index, 1);
			return { ...prevValues, [arrayName]: updatedArray };
		});
	};


	return (
		<>
			<Toaster />
			<Main title='Hierarchy Management' width='90vw' height='90vh'>
				<Header >
					<div className='flex'>
						<Button type='save' onClick={() => setShowForm(true)}>
							+ New
						</Button>
					</div>
					<div className='flex'>
						<Instruction keyId={'hierarchyManagement'}/>
						<Button type='close' onClick={onClose}>
							Close
						</Button>
					</div>
				</Header>
				<Body>
					<div ref={ref} className='h-[75vh] pt-2 printable overflow-auto'>
						<Table width='100%' innerWidth={['5%', '10%', '20%', '5%', '5%', '10%', '10%']}>
							<Thead>
								<Tr>
									<Th position={0}>Sl.No.</Th>
									<Th position={1}>Role</Th>
									<Th position={2}>Persons</Th>
									<Th position={3}>Effect From</Th>
									<Th position={4}>Effect To</Th>
									<Th position={5}>Action</Th>
								</Tr>
							</Thead>
							<Tbody height='auto'>
								{tableData?.map((x: any, i: number) => (
									<Tr>
										<Td index={i} position={0}>
											{i + 1}
										</Td>

										<Td index={i} position={1}>
											{x?.role}
										</Td>
										<Td index={i} position={2}>
											{x?.users?.map((x: any) => x?.name)?.join(', ')}
										</Td>
										<Td index={i} position={3}>
											{new Date(x?.effectFrom).toDateString()}

										</Td>
										<Td index={i} position={4}>
											{new Date(x?.effectTo).toDateString()}
										</Td>
										<Td index={i} position={5}>
											<div className='flex'>
												<Button
													type='update'
													onClick={() => {
														// setValues(x);
														editvalues(x._id);
														setShowForm(true);
													}}>
													Edit
												</Button>
												<Button type='delete' onClick={() => handleDelete(x?._id)}>
													Delete
												</Button>
											</div>
										</Td>
									</Tr>
								))}
							</Tbody>
						</Table>
					</div>
				</Body>
			</Main>

			{showForm && (
				<Main width='80vw' height='100%'>
					<Header>
						<Button
							type='close'
							onClick={() => {
								closeAnimation();
								setTimeout(() => { setShowForm(false); setValues({}) }, 500);
							}}>
							Close
						</Button>
					</Header>
					<Body>
						<div className='flex flex-col w-full'>
							<Input2 width='100%' fieldName='Hierarchy Tittle.' keyId='2k4k' returnKey='role' state={values} setState={setValues} type='text' />

							<div>
								{values?.users?.length >= 0 ? (
									<>
										{values?.users?.map((member: any, index: any) => (
											<div key={member.id || index} className='bg-white shadow-md p-4 rounded-lg mb-4'>
												<div className='flex justify-between items-center'>
													<span className='text-lg font-bold'>Person {index + 1}</span>
													<Button type='close' onClick={() => onDelete(index, 'users')}>
														Delete
													</Button>
												</div>
												<div key={index + 1} className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4'>
													<Input2
														className='w-full h-fit'
														isArray={true}
														indexVal={index}
														arrayName='users'
														fieldName='Nature of Appointment *'
														returnKey='type'
														state={values}
														setState={setValues}
														options={[
															{ key: 'permanent', display: 'Permanent' },
															{ key: 'temporary', display: 'Temporary' }
														]}
														optionKey='key'
														optionDisplay='display'
														type='drop'
													/>
													<Input2 className='w-full' isArray={true} indexVal={index} arrayName='users' didntShowKey={true} fieldName='Select Persons *' returnKey='usersIds' optionKey='_id' optionDisplay='name' state={values} setState={setValues} options={collegeUsers}
														type='mdrop' />

													<Input2 width='100%' isArray={true} indexVal={index} arrayName='users' fieldName='With Effect From *' returnKey='effectFrom' state={values} setState={setValues} type='date' />
													<Input2 width='100%' isArray={true} indexVal={index} arrayName='users' fieldName='With Effect To *' returnKey='effectTo' state={values} setState={setValues} type='date' />
												</div>
											</div>
										))}
										<Button type='save' onClick={() => onAddClick('users')}>
											Add +
										</Button>
									</>
								) : (
									<>
										<span className='text-center text-gray-500 my-10'>Add users Members</span>
										<Button type='save' onClick={() => onAddClick('users')}>
											Add +
										</Button>
									</>
								)}
							</div>


							<Button
								type='save'
								onClick={() => {
									valuesForm();
								}}>
								Save
							</Button>
						</div>
					</Body>
				</Main>
			)}
		</>
	);
}

export default HierarchyManagemant;
